import(/* webpackMode: "eager" */ "/vercel/path0/apps/storefront/app/[locale]/(default)/error.tsx");
